import { BottomNav } from '@/components/nav/BottomNav';
import { useClaimStashedReferral } from '@/hooks/useReferralClaim';
import { ChatSessionProvider } from '@/providers/ChatSessionProvider';
import { TallyFeedbackFormProvider } from '@/providers/TallyFeedbackFormProvider';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/_consumer')({
  component: ConsumerLayout,
});

/**
 * Pathless layout for consumer-facing routes. It mounts the consumer chat
 * session, the Tally feedback form, and the bottom nav. Admin routes live
 * outside this layout (under `/_protected/admin`) so they never mount the chat
 * session, which would otherwise auto-start a fresh conversation in the
 * background.
 */
function ConsumerLayout() {
  useClaimStashedReferral();

  return (
    <ChatSessionProvider>
      <TallyFeedbackFormProvider>
        <Outlet />
        <BottomNav />
      </TallyFeedbackFormProvider>
    </ChatSessionProvider>
  );
}
